import React from 'react';
import QcSymbology from '@Views/QualityControl/styles/symbology.scss';
import { ICircleObjectProps } from '../PlanView';
import { getCoordinatesOfPointOnCircle } from '../helpers';

interface ISpanLineProps extends ICircleObjectProps {
    type: SpanType;
}

export enum SpanType {
    FORE,
    BACK,
    DROP,
    OTHER,
}

const mainTypes = [SpanType.FORE, SpanType.BACK];

export const SpanLine = (props: ISpanLineProps) => {
    const circleIntersection = getCoordinatesOfPointOnCircle(
        props.circleRadius,
        props.bearing,
        {
            x: props.circleCenter,
            y: props.circleCenter,
        }
    );

    let strokeColor;
    switch (props.type) {
        case SpanType.FORE:
            strokeColor = QcSymbology.forePole;
            break;
        case SpanType.BACK:
            strokeColor = QcSymbology.backPole;
            break;
        case SpanType.DROP:
            strokeColor = QcSymbology.dropSpan;
            break;
        case SpanType.OTHER:
            strokeColor = QcSymbology.span;
            break;
    }

    return (
        <line
            x1={props.circleCenter}
            y1={props.circleCenter}
            x2={circleIntersection.x}
            y2={circleIntersection.y}
            stroke={strokeColor}
            strokeWidth={mainTypes.includes(props.type) ? 3 : 2}
            strokeOpacity={mainTypes.includes(props.type) ? 0.75 : 0.5}
        />
    );
};
